import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  FormGroup,
  Grid,
  MenuItem,
  Paper,
  TextField,
  Autocomplete
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { MAIN_URL } from "../../../Configurations/Urls";
import useAuthStore from "../../../Zustand/Store/useAuthStore";
import axios from "axios";
import toast from "react-hot-toast";
import Header from "../../DataLayouts/Header";
import { formatDate } from "../../../Utils/DateAndTime";
const STATUS_OPTIONS = [
  "Planned",
  "In Progress",
  "Completed",
  "Delayed",
  "Cancelled",
];
function ProjectMileStoneForm() {

  const navigate = useNavigate();
  const { id } = useParams(); // if id is present => edit mode
  const mode = id ? "edit" : "add";

  const { userData } = useAuthStore();

  console.log("full uer data is : ", userData);

  const org = userData?.organization;

  const fetchProjectMilestones = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${MAIN_URL}/api/project-management/project-milestone/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = res.data?.data;
      if (data) {
        setFormData({
          organization_project_id: data.organization_project_id || "",
          organization_id: data.organization_id || "",
          organization_entity_id: data.organization_entity_id || "",
          milestone_title: data.milestone_title || "",
          milestone_code: data.milestone_code || "",
          description: data.description || "",
          start_date: formatDate(data.start_date) || "",
          due_date: formatDate(data.due_date) || "",
          // completed_date: formatDate(data.completed_date) || "",
          status: data.status || "",
          is_billable: data.is_billable || false
        });
      }
    } catch (error) {
      toast.error("Failed to fetch project milestone data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (mode === "edit" && id) {
      fetchProjectMilestones();
    }
  }, [mode, id]);

  const [formData, setFormData] = useState({
    organization_id: org?.organization_id || "",
    organization_entity_id: "",
    organization_project_id: "",
    milestone_title: "",
    milestone_code: "",
    description: "",
    start_date: "",
    due_date: "",
    // completed_date: "",
    status: "",
    is_billable: false
  });

  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  const validateForm = () => {
    const errors = {};

    if (!formData.organization_project_id) {
      errors.organization_project_id = "Project is required";
    }
    if (!formData.milestone_title) {
      errors.milestone_title = "Milestone title is required";
    } else if (formData.milestone_title.length > 150) {
      errors.milestone_title = "Milestone title must not exceed 150 characters";
    }

    if (formData.milestone_code && formData.milestone_code?.length > 100) {
      errors.milestone_code = "Milestone code must not exceed 100 characters";
    }

    if (formData.description && formData.description.length > 255) {
      errors.description = "Description must not exceed 100 characters";
    }

    if (formData.due_date && !formData.start_date) {
      errors.start_date = "Start date is required if due date given";
    }

    if (formData.start_date && formData.due_date && new Date(formData.due_date) < new Date(formData.start_date)) {
      errors.due_date = "Due date must be after or equal to start date";
    }

    // if (formData.completed_date) {
    //   if (new Date(formData.completed_date) < new Date(formData.start_date)) {
    //     errors.completed_date = "Completed date must be after or equal to start date";
    //   }
    // }

    if (formData.status && !['Planned', 'In Progress', 'Completed', 'Delayed', 'Cancelled'].includes(formData.status)) {
      errors.status = "Status must be one of: pending, in_progress, completed, or cancelled";
    }

    if (formData.is_billable !== true && formData.is_billable !== false) {
      errors.is_billable = "Billable field must be true or false";
    }


    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const [selectOptions, setSelectOptions] = useState({
    Projects: []
  })

  const fetchProjects = async () => {
    try {
      const response = await axios.get(`${MAIN_URL}/api/project-management/projects`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          per_page: "all",
          organization_id: org?.organization_id,
        },
      });

      console.log("response projects is : ", response);

      setSelectOptions((prev) => ({ ...prev, Projects: response.data.data }));
    } catch (e) {
      console.error("Failed to load projects");
    }
  };

  useEffect(() => {
    if(org?.organization_id){fetchProjects();}
    
  }, []);


  // Submit form
  const handleSubmit = async () => {
    setFormErrors({});

    if (!validateForm()) {
      toast.error("Please fix the validation errors.");
      return;
    }

    let organization_entity_id = userData?.organization?.
      entities?.organization_entity_id || null;
    console.log("organization_entity_id is : ", organization_entity_id);


    setBtnLoading(true);
    try {
      const token = localStorage.getItem("token");
      if (mode === "edit") {
        await axios.put(`${MAIN_URL}/api/project-management/project-milestone/${id}`, { ...formData, organization_entity_id }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        toast.success("Project MileStone updated");
      } else {
        await axios.post(`${MAIN_URL}/api/project-management/project-milestone`, { ...formData, organization_entity_id }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        toast.success("Project MileStone added");
      }

      navigate("/project-milestone");
    } catch (err) {
      if (err.response?.status === 422) {
        toast.error("Please fix the validation errors.");
        setFormErrors(err.response.data.errors);
      } else {
        toast.error("Operation failed");
      }
    }
    setBtnLoading(false);
  };


  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prev) => ({ ...prev, [name]: "" }));
  };


  return (
    <Box px={4} py={4}>
      <Header
        mode={mode}
        updateMessage={"Project MileStones"}
        addMessage={"Project MileStones"}
        homeLink={"/project-milestone"}
        homeText={"Project MileStones"}
      />

      {loading ? (
        <Box display="flex" justifyContent="center" py={4}>
          <CircularProgress />
        </Box>
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12} md={8}>
            <Paper elevation={4} sx={{ p: 3 }}>
              <Grid container spacing={2}>


             

<Autocomplete
  fullWidth
  options={selectOptions?.Projects || []}
  getOptionLabel={(option) => option.project_name || ""}
  value={
    selectOptions?.Projects?.find(
      (project) =>
        project.organization_project_id === formData.organization_project_id
    ) || null
  }
  onChange={(event, newValue) => {
    setFormData((prev) => ({
      ...prev,
      organization_project_id:
        newValue?.organization_project_id || "",
    }));
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      label="Project *"
      error={!!formErrors.organization_project_id}
      helperText={formErrors.organization_project_id}
    />
  )}
/>


                <TextField
                  fullWidth
                  label="MileStone Title *"
                  name="milestone_title"
                  value={formData.milestone_title}
                  onChange={handleChange}
                  error={!!formErrors.milestone_title}
                  helperText={formErrors.milestone_title}
                />

                <TextField
                  fullWidth
                  label="MileStone Code "
                  name="milestone_code"
                  value={formData.milestone_code}
                  onChange={handleChange}
                  error={!!formErrors.milestone_code}
                  helperText={formErrors.milestone_code}
                />

                <TextField
                  fullWidth
                  multiline
                  minRows={3}
                  label="Description "
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  error={!!formErrors.description}
                  helperText={formErrors.description}
                />


                <TextField
                  fullWidth
                  label="Start Date "
                  name="start_date"
                  type="date"
                     
                  InputLabelProps={{ shrink: true }}
                  value={formData.start_date}
                  onChange={handleChange}
                  error={!!formErrors.start_date}
                  helperText={formErrors.start_date}
                />
                <TextField
                  fullWidth
                  label="Due Date "
                  name="due_date"
                  type="date"
                     
                  InputLabelProps={{ shrink: true }}
                  value={formData.due_date}
                  onChange={handleChange}
                  error={!!formErrors.due_date}
                  helperText={formErrors.due_date}
                />

                {/* <TextField
                  fullWidth
                  label="Completed Date "
                  name="completed_date"
                  type="date"
                     
                  InputLabelProps={{ shrink: true }}
                  value={formData.completed_date}
                  onChange={handleChange}
                  error={!!formErrors.completed_date}
                  helperText={formErrors.completed_date}
                /> */}

              



<Autocomplete
  fullWidth
  options={STATUS_OPTIONS}
  value={formData.status || null}
  onChange={(event, newValue) => {
    setFormData((prev) => ({
      ...prev,
      status: newValue || "",
    }));
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      label="Status"
      error={!!formErrors.status}
      helperText={formErrors.status}
    />
  )}
/>


                <FormGroup row sx={{ mt: 2 }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="is_billable"
                        checked={formData.is_billable}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            is_billable: e.target.checked,
                          })
                        }
                      />
                    }
                    label="Is Billable"
                  />
                </FormGroup>


              </Grid>
              <Button
                variant="contained"
                color="primary"
                size="medium"
                onClick={handleSubmit}
                disabled={loading || btnLoading}
                sx={{
                  borderRadius: 2,
                  minWidth: 120,
                  textTransform: "capitalize",
                  fontWeight: 500,
                  mt: 2
                }}
              >
                {loading || btnLoading ? (
                  <CircularProgress size={22} sx={{ color: "#fff" }} />
                ) : mode === "edit" ? (
                  "Update"
                ) : (
                  "Submit"
                )}
              </Button>

            </Paper>
          </Grid>
        </Grid>
      )}

    </Box>
  )
}

export default ProjectMileStoneForm